import { render, staticRenderFns } from "./PriceChartMini.vue?vue&type=template&id=653fe5cb&scoped=true&"
import script from "./PriceChartMini.vue?vue&type=script&lang=js&"
export * from "./PriceChartMini.vue?vue&type=script&lang=js&"
import style0 from "./PriceChartMini.vue?vue&type=style&index=0&id=653fe5cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653fe5cb",
  null
  
)

export default component.exports